import script from "./PasswordResetRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetRequest.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetRequest.vue?vue&type=style&index=0&id=41ab844d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41ab844d"]])

export default __exports__